import { createStore } from "satcheljs";
import { TeamSetupPickerStore } from "./schema/TeamSetupPickerStore";

/**
 * Team picker panel view state
 */
const initialTeamSetupPickerStore: TeamSetupPickerStore = {
    setupSequence: null,
    currentSetupStepIndex: -1,
    teamSetupInfo: {
        msTeamInfo: null,           // MS Team info
        timeZoneOlsonCode: null     // Team timezone
    },
    isProvisionTeamInProgress: false,   // true if the schedule team is currently being provisioned
    errorMessage: null,                 // Set with an error message string to display an error
    showStepIndicator: true,             // true shows the step indicator component in the setup dialog
    selectedTeamCategoryType: "Active",
    restorableSchedules: []              // Restorable schedules for the currently selected team
};

const teamSetupPickerStore = createStore("teamSetupPickerStore", initialTeamSetupPickerStore)();
export default teamSetupPickerStore;

/* export actions and mutator actions for ease of import */
export { default as setTeamSetupPickerSequence } from "../mutatorActions/setTeamSetupPickerSequence";
export { default as gotoNextSetupStep } from "../mutatorActions/gotoNextSetupStep";
export { default as gotoPrevSetupStep } from "../mutatorActions/gotoPrevSetupStep";
export { default as setMSTeamInfo } from "../mutatorActions/setMSTeamInfo";
export { default as setTeamSetupTimezone } from "../mutatorActions/setTeamSetupTimezone";
export { default as setErrorMessage } from "../mutatorActions/setErrorMessage";
export { default as setIsProvisionTeamInProgress } from "../mutatorActions/setIsProvisionTeamInProgress";
export { default as setShowStepIndicator } from "../mutatorActions/setShowStepIndicator";
export { default as setSelectedTeamCategoryType } from "../mutatorActions/setSelectedTeamCategoryType";
export { default as setRestorableSchedules } from "../mutatorActions/setRestorableSchedules";
export { default as setSelectedMSTeam } from "../mutatorActions/setSelectedMSTeam";
export { default as setTeamSetupTeamDisplayName } from "../mutatorActions/setTeamSetupTeamDisplayName";
export { default as setTeamSetupMembers } from "../mutatorActions/setTeamSetupMembers";
export { default as setTeamSetupSchedulingGroupName } from "../mutatorActions/setTeamSetupSchedulingGroupName";
export { default as setTeamSetupChannelName } from "../mutatorActions/setTeamSetupChannelName";
